"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BundleResponse = void 0;
/**
 * Indicates the results of processing the corresponding 'request' entry in the batch or transaction being responded to or what the results of an operation where when returning history.
 */
var BundleResponse = /** @class */ (function () {
    function BundleResponse() {
    }
    return BundleResponse;
}());
exports.BundleResponse = BundleResponse;
